
import { SERVICES_API } from "../config/api";

class AccountsService {

    // Consult if the client has a Current Account ====================================================================================================

    /**
     * Consult if the client has a Current Account
     * @type {object}
     * @property {string} DNI
     * @returns {object} - True or false if the client has a current account
    */
    consultaCuentaCorriente(data) {
        const url = `/consultaCuentaCorriente`;

        return SERVICES_API.post(url, data);
    }

    
    // Consult if the client has an Active Product ====================================================================================================

    /**
     * Consult if the client has an Active Product
     * @type {object}
     * @property {string} DNI
     * @returns {object} - True or false if the client has an active product
    */
    consultaProductoActivo(data) {
        const url = `/consultaProductoActivo`;

        return SERVICES_API.post(url, data);
    }


    // Open Account ====================================================================================================

    /**
     * Open Account
     * @type {object}
     * @property {string} chequerasprevias - false
     * @property {string} envio - D
     * @property {number} usaLibreta - 0
     * @property {number} origenFondos
     * @property {object} apartado
     * @property {number} apartado.ciudad
     * @property {number} apartado.codigoSucursal
     * @property {number} apartado.entidad
     * @property {number} apartado.id - 0
     * @property {number} apartado.numero - 1
     * @property {number} apartado.sucursal
     * @property {number} apartado.tipo - 0
     * @property {object} aperturaCuentaBean
     * @property {string} aperturaCuentaBean.categoriaCuenta
     * @property {string} aperturaCuentaBean.condicionFirma - Prueba
     * @property {number} aperturaCuentaBean.detalle - 10586851
     * @property {number} aperturaCuentaBean.firmas - 1
     * @property {number} aperturaCuentaBean.montoDeposito - 1
     * @property {string} aperturaCuentaBean.descripcionMontDep
     * @property {number} aperturaCuentaBean.montoRetiro - 1
     * @property {string} aperturaCuentaBean.descripcionMontRet
     * @property {number} aperturaCuentaBean.motivoApertura
     * @property {string} aperturaCuentaBean.nombreTitular
     * @property {number} aperturaCuentaBean.numeroAutorizados - 0
     * @property {string} aperturaCuentaBean.oficial - bc22334
     * @property {number} aperturaCuentaBean.paisDestino - 0 or country code
     * @property {number} aperturaCuentaBean.paisOrigen - 0 or country code
     * @property {number} aperturaCuentaBean.totalApertura - 0.0
     * @property {number} aperturaCuentaBean.transferencia - 0
     * @property {number} aperturaCuentaBean.uso
     * @property {number} aperturaCuentaBean.cantDepositos
     * @property {number} aperturaCuentaBean.cantRetiros
     * @property {string} aperturaCuentaBean.montoPromedioVES
     * @property {number} aperturaCuentaBean.cantDepositosUSD
     * @property {number} aperturaCuentaBean.cantRetirosUSD
     * @property {string} aperturaCuentaBean.montoPromedioUSD
     * @property {number} aperturaCuentaBean.cantDepositosCOP
     * @property {number} aperturaCuentaBean.cantRetirosCOP
     * @property {string} aperturaCuentaBean.montoPromedioCOP
     * @property {number} aperturaCuentaBean.cantDepositosEUR
     * @property {number} aperturaCuentaBean.cantRetirosEUR
     * @property {string} aperturaCuentaBean.montoPromedioEUR
     * @property {object} direccion
     * @property {number} direccion.codigoDireccion
     * @property {string} direccion.descripcionDireccion
     * @property {string} direccion.tipoDireccion
     * @property {object} participantes.ParticipanteBean
     * @property {string} participantes.ParticipanteBean.BDSeguridad
     * @property {number} participantes.ParticipanteBean.actividadEconomica
     * @property {string} participantes.ParticipanteBean.cedula
     * @property {number} participantes.ParticipanteBean.ciiu
     * @property {number} participantes.ParticipanteBean.codOficina
     * @property {number} participantes.ParticipanteBean.codigoMis
     * @property {number} participantes.ParticipanteBean.codigoMisRepresentante - 0
     * @property {string} participantes.ParticipanteBean.comentarios - Apartura Cuenta Onboarding
     * @property {object} participantes.ParticipanteBean.direcciones.Direcciones
     * @property {number} participantes.ParticipanteBean.direcciones.Direcciones.codigoDireccion
     * @property {string} participantes.ParticipanteBean.direcciones.Direcciones.descripcionDireccion
     * @property {string} participantes.ParticipanteBean.direcciones.Direcciones.tipoDireccion
     * @property {string} participantes.ParticipanteBean.edoCivil
     * @property {number} participantes.ParticipanteBean.esOficinaBangente - 0
     * @property {string} participantes.ParticipanteBean.fechaNacimiento
     * @property {string} participantes.ParticipanteBean.fechaUltimaModificacion - 2022-06-27T15:15:22-04:30
     * @property {string} participantes.ParticipanteBean.fechaVenceIdentificacion
     * @property {string} participantes.ParticipanteBean.firmar - true
     * @property {number} participantes.ParticipanteBean.fuenteOrigen
     * @property {number} participantes.ParticipanteBean.grupoEconomico
     * @property {number} participantes.ParticipanteBean.identificacion - 0
     * @property {number} participantes.ParticipanteBean.lenguaje - 0
     * @property {number} participantes.ParticipanteBean.lugarNacimiento
     * @property {number} participantes.ParticipanteBean.nacionalidad
     * @property {string} participantes.ParticipanteBean.nombre
     * @property {number} participantes.ParticipanteBean.oficina
     * @property {number} participantes.ParticipanteBean.pais
     * @property {number} participantes.ParticipanteBean.patrimonioTecnico - 0
     * @property {number} participantes.ParticipanteBean.profesion
     * @property {number} participantes.ParticipanteBean.provincia - estado
     * @property {number} participantes.ParticipanteBean.referencia - 0
     * @property {string} participantes.ParticipanteBean.referenciasBancarias - false
     * @property {number} participantes.ParticipanteBean.riskCodPais - 0
     * @property {string} participantes.ParticipanteBean.rol - T
     * @property {number} participantes.ParticipanteBean.segmento - 0
     * @property {string} participantes.ParticipanteBean.sexo
     * @property {number} participantes.ParticipanteBean.subSegmento - 0
     * @property {string} participantes.ParticipanteBean.tipoCliente - T
     * @property {string} participantes.ParticipanteBean.tipoFirma - X
     * @property {number} participantes.ParticipanteBean.tipoIdentificacion - 1
     * @property {string} participantes.ParticipanteBean.tipoPersona - N
     * @property {string} participantes.ParticipanteBean.venezolano
     * @property {number} participantes.ParticipanteBean.vinculacion - 0
     * @property {object} producto
     * @property {string} producto.categoria
     * @property {number} producto.codigo
     * @property {string} producto.codigoCuenta
     * @property {object} producto.moneda
     * @property {string} producto.moneda.codigoBanco - 1
     * @property {string} producto.moneda.codigoISO
     * @property {string} producto.moneda.extranjera
     * @property {number} producto.tipoCuenta
     * @returns {object} - True or false if the account was opened
    */
    aperturaCuentas(data) {
        const url = `/aperturaCuentas`;

        return SERVICES_API.post(url, data);
    }

}

export default new AccountsService();